import { render } from "./ConversationReactionOptions.vue?vue&type=template&id=3bc1eacc"
import script from "./ConversationReactionOptions.vue?vue&type=script&lang=js"
export * from "./ConversationReactionOptions.vue?vue&type=script&lang=js"
script.render = render

export default script